var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Incidents'),_c('Help',{on:{"open":_vm.showModal}}),_c('HelpModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalVisible),expression:"isModalVisible"}],on:{"close":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }